/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcRaglV1TransactionState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_RAGL_V1_TRANSACTION_STATE_ENTITY_NAME = 'ixc.ragl.v1.Transaction';
export const ixcRaglV1TransactionStateEntity = new schema.Entity<IxcRaglV1TransactionState>(IXC_RAGL_V1_TRANSACTION_STATE_ENTITY_NAME, {}, { idAttribute: 'transactionId' });

